/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Gpsubreasonlabel4Inputs */

const en_coinvestments_declinedeal_gpsubreasonlabel4 = /** @type {(inputs: Coinvestments_Declinedeal_Gpsubreasonlabel4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-reason`)
};

/**
* | output |
* | --- |
* | "Sub-reason" |
*
* @param {Coinvestments_Declinedeal_Gpsubreasonlabel4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_gpsubreasonlabel4 = /** @type {((inputs?: Coinvestments_Declinedeal_Gpsubreasonlabel4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Gpsubreasonlabel4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_gpsubreasonlabel4(inputs)
});
export { coinvestments_declinedeal_gpsubreasonlabel4 as "coInvestments_declineDeal_gpSubreasonLabel" }